import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { SpraySubmissionState } from './types';

const selectSpraySubmission = (state: AppState): SpraySubmissionState =>
    state.spraySubmission;

const selectSpraySubmissionArray = createDeepEqualSelector(
    selectSpraySubmission,
    (submission) => (submission && Object.values(submission)) || []
);

const selectSpraySubmissionHasError = createDeepEqualSelector(
    selectSpraySubmissionArray,
    (submission) =>
        submission.some((submissionProduct) => submissionProduct.errorMessage)
);

export {
    selectSpraySubmission,
    selectSpraySubmissionArray,
    selectSpraySubmissionHasError
};
